module.exports = __webpack_public_path__ + "img/hd_05.921c9077.png";